import { render, staticRenderFns } from "./slideup-mobile.vue?vue&type=template&id=472f8484&scoped=true&"
import script from "./slideup-mobile.vue?vue&type=script&lang=js&"
export * from "./slideup-mobile.vue?vue&type=script&lang=js&"
import style0 from "./slideup-mobile.vue?vue&type=style&index=0&id=472f8484&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472f8484",
  null
  
)

export default component.exports